import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'src/app/models/auth';
import { SaldoPessoa } from 'src/app/models/saldo-pessoa';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CedenteService } from 'src/app/services/cedente.service';
import { BalanceService } from 'src/app/services/balance.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { TipoSaldoPessoa } from 'src/app/shared/enums/tipo-saldo-pessoa.enum';

@Component({
  selector: 'app-saldo',
  templateUrl: './saldo.component.html',
  styleUrls: ['./saldo.component.css']
})
export class SaldoComponent implements OnInit {

    public currentUser: Auth;
    public availableBalance = 0;
    public depositsTotalBalance = 0;
    public currentBalance: SaldoPessoa[];

    public isAvailableBalanceLoading = true;
    public isDepositsTotalBalanceLoading = true;

    constructor(
        private router: Router,
        private balanceService: BalanceService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService
    ) { }

    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        //this.currentBalance = this.cedenteService.currentBalanceValue;
        //this.saldoDisponivel = this.currentBalance.find(x => x.id === TipoSaldoPessoa.SaldoDisponivel).valor;
        this.balanceService.getTotalBalanceAvailable(this.currentUser.token.assignorGuid)
                .subscribe(response => {
                    if (response.status === ApiError.Sucesso) {
                        this.availableBalance = response.result;
                        this.isAvailableBalanceLoading = false;
                    } else {
                        this.alertService.error(response.message);
                    }
            });

        this.balanceService.getDepositsTotalBalance(this.currentUser.token.assignorGuid)
            .subscribe(
                response => {
                    if (response.status === ApiError.Sucesso) {
                        this.depositsTotalBalance = response.result;
                        this.isDepositsTotalBalanceLoading = false;
                    } else {
                        this.alertService.error(response.message);
                    }
                }
            );
    }

    adicionarCreditos() {
        this.router.navigate(['portal/depositos-pagamentos/list']);
    }

    verExtrato() {
        this.router.navigate(['portal/extrato/list']);
    }

    verDepositos() {
        this.router.navigate(['portal/depositos-pagamentos/list']);
    }

}
